"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modalZIndex = void 0;
const file_browser_scss_1 = __importDefault(require("./file-browser.scss"));
exports.modalZIndex = file_browser_scss_1.default.baseZIndex;
//# sourceMappingURL=z-index.js.map